// extracted by mini-css-extract-plugin
export default {"book__title":"BookTitle_book__title__C8D06"};